import { inject, Injectable, Optional } from '@angular/core';
import { APP_CONFIG, AppConfig } from '../config/app-config';

/**
 * Lists known feature flags.
 *
 * This enum should not be considered to be an exhaustive list. Consider it more as
 * documentation.
 */
export enum KnownFeatureFlags {
    aiChat = 'aiChat',
    downloadSearchResults = 'downloadSearchResults',
    qaControls = 'qaControls',
}

@Injectable({
    providedIn: 'root',
})
export class FeatureFlagService {
    private readonly featureFlags: Record<string, boolean> = {};
    @Optional() private readonly config: AppConfig = inject(APP_CONFIG);

    constructor() {
        if (this.config) {
            this.featureFlags = {
                ...this.featureFlags,
                ...this.config.featureFlags,
            };
        }
    }

    isFlagEnabled(flag: KnownFeatureFlags | string | null | undefined) {
        if (null == flag) {
            return false;
        }
        return this.featureFlags && !!this.featureFlags[flag];
    }
}
